<!-- menu heading -->
<span *ngIf="item.heading; else menuItem">{{(item.translate | translate) || item.text}}</span>

<ng-template #menuItem>
    <!-- has submenu -->
    <!-- [ngClass]="{'active': isActive}" -->
    <a class="horizontal-nav-item" href *ngIf="item.submenu; else linkItem"  title="{{item.text}}" (click)="toggleSubmenuClick.emit($event)">
        <em *ngIf="item.icon" [ngClass]="item.icon" class="icon"></em>
        <span *ngIf="item.alert" class="float-right" [ngClass]="item.label || 'badge badge-success'">{{item.alert}}</span>
        <span class="text">{{(item.translate | translate) || item.text}}</span>
    </a>

    <ng-template #linkItem>
        <!-- external links -->
        <a class="horizontal-nav-item" href *ngIf="item.elink" [attr.target]="item.target" [attr.href]="item.elink" title="{{item.text}}">
            <em *ngIf="item.icon" class="{{item.icon}}" class="icon"></em>
            <span *ngIf="item.alert" class="float-right" [ngClass]="item.label || 'badge badge-success'">{{item.alert}}</span>
            <span class="text">{{(item.translate | translate) || item.text}}</span>
        </a>
        <!-- single menu item --> 
        <a class="horizontal-nav-item" href *ngIf="!item.elink" [routerLink]="item.link" [routerLinkActive]="['active']" [attr.route]="item.link" title="{{item.text}}"
            (click)="toggleSubmenuClick.emit($event)">
            <em *ngIf="item.icon" class="{{item.icon}}" class="icon"></em>
            <span *ngIf="item.alert" class="float-right" [ngClass]="item.label || 'badge badge-success'">{{item.alert}}</span>
            <span class="text">{{(item.translate | translate) || item.text}}</span>
        </a>
    </ng-template>
</ng-template>